import { fetchSentMessage, resendMessage } from 'api/SentMessagesAPI';
import { call, put, takeLatest } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { getErrorResponse } from 'utils/xhr';
import { addNegativeToast, addPositiveToast } from 'modules/toastContainer/utils';
import * as actions from './actions';
import * as actionTypes from './actionTypes';

export function* fetchSentMessageSaga({
  payload,
}: ReturnType<typeof actions.fetchSentMessageRequest>) {
  try {
    const { data } = yield call(fetchSentMessage, payload);
    yield put(actions.fetchSentMessageResponse({ data }));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(actions.fetchSentMessageError());
    const message = `Error fetching sent message. ${err}`;
    yield put(addNegativeToast(message));
  }
}

export function* resendMessageSaga({
  payload,
  campaignName,
}: ReturnType<typeof actions.resendMessageRequest>) {
  const { recipient, ...rest } = payload;
  try {
    const requestPayload = { recipient, ...rest };
    yield call(resendMessage, requestPayload);
    const message = `Success! Resent ${campaignName} to ${recipient}.`;
    yield put(addPositiveToast(message));
  } catch (error) {
    const err = getErrorResponse(error);
    const message = `Could not resend ${campaignName} to ${recipient}. Please try again. ${err}`;
    yield put(addNegativeToast(message));
  }
}

addToRootSaga([
  takeLatest(actionTypes.FETCH_SENT_MESSAGE_REQUEST, fetchSentMessageSaga),
  takeLatest(actionTypes.RESEND_MESSAGE_REQUEST, resendMessageSaga),
]);
